export const DiscountTypeToggle = ({ value, onChange, testId, dark }) => (
  <div className={`inline-flex rounded-md border p-0.5 ${dark ? "border-slate-700 bg-slate-900" : "border-slate-200 bg-slate-50"}`} data-testid={testId}>
    {[["percent", "%"], ["amount", "₺"]].map(([v, l]) => (
      <button key={v} type="button" data-testid={`${testId}-${v}`} onClick={() => onChange(v)}
        className={`h-7 w-7 rounded text-xs font-bold transition-colors ${value === v ? (dark ? "bg-blue-600 text-white" : "bg-slate-950 text-white") : (dark ? "text-slate-400 hover:text-white" : "text-slate-500 hover:text-slate-950")}`}>
        {l}
      </button>
    ))}
  </div>
);

export const Logo = ({ size = "h-9 w-9", light }) => (
  <div className="flex items-center gap-2">
    <img src="/logo.jpg" alt="Ekol Temizlik" className={`${size} rounded-md object-cover ${light ? "" : "ring-1 ring-slate-200"}`} />
    <div className="leading-none">
      <span className={`font-display text-lg font-bold tracking-tight ${light ? "text-white" : "text-[#0f1f4b]"}`}>Ekol Temizlik</span>
      <span className={`block font-mono text-[9px] uppercase tracking-[0.2em] ${light ? "text-cyan-300" : "text-cyan-600"}`}>Sipariş Sistemi</span>
    </div>
  </div>
);
